import { ButtonInterface } from 'common/types/entities/button-interface'
import { useClosePopup } from 'publisher/hooks/use-close-popup'
import useOptInSubmit from 'publisher/hooks/use-opt-in-submit-new'
import useBlog, { selectors as blogSelectors } from 'publisher/hooks/useBlog'
import React from 'react'
import { BasePublisherButton } from 'src/publisher/entities/base-publisher-button'

const TEST_ID = 'blog-send-form-button'

export interface BlogSendFormButtonProps {
  entity: ButtonInterface
}

const BlogSendFormButton = ({ entity }: BlogSendFormButtonProps) => {
  const blogLayoutPageId = useBlog(blogSelectors.getBlogLayoutPageId)
  const closePopup = useClosePopup(entity, blogLayoutPageId)

  const [isLoading, errors, submit, isSuccess] = useOptInSubmit({
    optInButtonEntity: entity,
    closePopup,
  })

  return (
    <BasePublisherButton
      entity={entity}
      isLoading={isLoading}
      errors={errors}
      onClick={submit}
      testId={TEST_ID}
      isSuccess={isSuccess}
    />
  )
}

export default BlogSendFormButton
